import { createSlice } from '@reduxjs/toolkit';
import { AppointmentState } from '../types/types';

const initialAppointmentState: AppointmentState = {
  client: {
    id: '',
    name: ''
  },
  medicalCenter: '',
  doctor: {
    id: '',
    name: ''
  },
  schedule: {
    datetimeInMilliseconds: 0
  },
  specialty: {
    code: '',
    name: '',
    color: ''
  }
};

const appointmentSlice = createSlice({
  name: 'appointment',
  initialState: initialAppointmentState,
  reducers: {
    setClient(state, action) {
      state.client.id = action.payload.clientId;
      state.client.name = action.payload.clientName;
    },
    setMedicalCenter(state, action) {
      state.medicalCenter = action.payload;
    },
    setDoctor(state, action) {
      state.doctor.id = action.payload.id;
      state.doctor.name = action.payload.name;
    },
    setSchedule(state, action: { payload: { datetimeInMilliseconds: number } }) {
      state.schedule.datetimeInMilliseconds = action.payload.datetimeInMilliseconds;
    },
    setSpecialty(state, action) {
      state.specialty.code = action.payload.code;
      state.specialty.name = action.payload.name;
      state.specialty.color = action.payload.color;
    },
    resetDoctor(state) {
      state.doctor = initialAppointmentState.doctor;
    },
    resetSchedule(state) {
      state.schedule = initialAppointmentState.schedule;
    },
    resetAppointment() {
      return initialAppointmentState;
    }
  }
});

export const appointmentActions = appointmentSlice.actions;

export default appointmentSlice.reducer;
